(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[937],{

/***/ 1665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);




var Input = function(_param) {
    var _decimalPlaces = _param.decimalPlaces, decimalPlaces = _decimalPlaces === void 0 ? 2 : _decimalPlaces, onChange = _param.onChange, _max = _param.max, max = _max === void 0 ? 650 : _max, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "decimalPlaces",
        "onChange",
        "max"
    ]);
    var changeHandler = function(e) {
        var regex = /^([0-9]*|[0-9]*\.[0-9]{0,2})$/;
        if (regex.test(e.target.value)) {
            onChange(e);
        }
    };
    var keydownHandler = function(e) {
        if (e.keyCode === 69) {
            e.preventDefault();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, rest), {
        type: "number",
        max: max,
        onChange: changeHandler,
        onKeyDown: keydownHandler
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 7900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Slider_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7122);
/* harmony import */ var _Slider_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Slider_module_css__WEBPACK_IMPORTED_MODULE_2__);



var Slider = function(param) {
    var value = param.value, onChange = param.onChange, _min = param.min, min = _min === void 0 ? 1 : _min, _max = param.max, max = _max === void 0 ? 100 : _max, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, color = param.color;
    var container = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createRef)(null);
    var sliderValue = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), active = ref[0], setActive = ref[1];
    var changeHandler = function(e) {
        onChange(e.target.value);
        sliderValue.current.style.transform = "translateX(-80%)";
        var newVal = Number((e.target.value - min) * 100 / (max - min));
        sliderValue.current.style.left = "calc(".concat(newVal, "% + (").concat(12 - newVal * 0.01, "px))");
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var eventHandler = function(e) {
            switch(e.type){
                case "touchstart":
                    return setActive(true);
                case "touchend":
                    return setActive(false);
                case "mousedown":
                    return setActive(true);
                case "mouseup":
                    return setActive(false);
            }
        };
        container.current.addEventListener("touchstart", eventHandler);
        container.current.addEventListener("touchend", eventHandler);
        container.current.addEventListener("mousedown", eventHandler);
        container.current.addEventListener("mouseup", eventHandler);
    });
    var generateClass = function(color) {
        switch(color){
            case "blue":
                return (_Slider_module_css__WEBPACK_IMPORTED_MODULE_2___default().calcSliderBlue);
            case "yellow":
                return (_Slider_module_css__WEBPACK_IMPORTED_MODULE_2___default().calcSliderYellow);
            case "green":
                return (_Slider_module_css__WEBPACK_IMPORTED_MODULE_2___default().calcSliderGreen);
            default:
                return (_Slider_module_css__WEBPACK_IMPORTED_MODULE_2___default().calcSlider);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_Slider_module_css__WEBPACK_IMPORTED_MODULE_2___default().sliderContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                ref: container,
                className: "".concat(generateClass(color)),
                type: "range",
                onChange: changeHandler,
                min: min,
                max: max,
                value: value,
                disabled: disabled
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Slider_module_css__WEBPACK_IMPORTED_MODULE_2___default().sliderValue),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Slider_module_css__WEBPACK_IMPORTED_MODULE_2___default().sliderSubcontainer),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h4", {
                        ref: sliderValue,
                        className: !active ? (_Slider_module_css__WEBPACK_IMPORTED_MODULE_2___default().inactive) : "",
                        children: [
                            value,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Slider);


/***/ }),

/***/ 9937:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_calculator_Slider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7900);
/* harmony import */ var _Calculator_module_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4576);
/* harmony import */ var _Calculator_module_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Calculator_module_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Input__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1665);
/* harmony import */ var _utils_heightHelpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1103);







var Bmi = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("kg"), weightMetric = ref[0], setWeightMetric = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("ft"), heightMetric = ref1[0], setHeightMetric = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), height = ref2[0], setHeight = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), weight = ref3[0], setWeight = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), foot = ref4[0], setFoot = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), inches = ref5[0], setInches = ref5[1];
    var renderText = function() {
        var bmi = calculateBMI(height, weight);
        // if (bmi < 18.5) {
        //   return "Underweight";
        // } else if (bmi > 18.5 && bmi < 25) {
        //   return "Normal";
        // } else if (bmi >= 25 && bmi < 30) {
        //   return "Overweight";
        // } else if (bmi >= 30 && bmi < 35) {
        //   return "Obese";
        // } else if (bmi >= 35) {
        //   return "Extremely Obese";
        // }
        if (bmi < 16) {
            return "Underweight (Severe)";
        } else if (bmi >= 16 && bmi < 17) {
            return "Underweight (Moderate)";
        } else if (bmi >= 17 && bmi < 18.5) {
            return "Underweight (Mild)";
        } else if (bmi >= 18.5 && bmi < 25) {
            return "Normal";
        } else if (bmi >= 25 && bmi < 30) {
            return "Overweight (Pre-Obese)";
        } else if (bmi >= 30 && bmi < 35) {
            return "Obesity (Extreme)";
        } else if (bmi >= 35 && bmi < 40) {
            return "Obesity (Morbid)";
        } else if (bmi >= 40) {
            return "Obesity (Fatal)";
        }
    };
    var calculateBMI = function(height, weight) {
        var w = weightMetric === "kg" ? weight : (0,_utils_heightHelpers__WEBPACK_IMPORTED_MODULE_4__/* .poundToKg */ .YB)(weight);
        console.log(w, parseInt(height), weight);
        var res = (w / (height * height / 10000)).toFixed(1);
        return res > 0 && res < 150 ? res : 0.0;
    };
    var calculateDeg = function() {
        var bmi = calculateBMI(height, weight);
        if (bmi < 18.5) {
            return -90;
        } else if (bmi > 18.5 && bmi < 25) {
            return 317 - 360;
        } else if (bmi >= 25 && bmi < 30) {
            return 0;
        } else if (bmi >= 30 && bmi < 35) {
            return 43;
        } else if (bmi >= 35) {
            return 77;
        }
    };
    var heightChangeHandler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(e) {
        var value = e.target.value;
        switch(e.target.name){
            case "heightFoot":
                value ? setFoot(parseFloat(value)) : setFoot("");
                setHeight((0,_utils_heightHelpers__WEBPACK_IMPORTED_MODULE_4__/* .feetToCM */ .yE)(e.target.value, inches));
                break;
            case "heightInches":
                value ? setInches(parseFloat(value)) : setInches("");
                setHeight((0,_utils_heightHelpers__WEBPACK_IMPORTED_MODULE_4__/* .feetToCM */ .yE)(foot, e.target.value));
                break;
            default:
                break;
        }
    }, [
        foot,
        inches
    ]);
    var heightSliderChangeHandler = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(value) {
        setHeight(value);
        switch(heightMetric){
            case "ft":
                var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_utils_heightHelpers__WEBPACK_IMPORTED_MODULE_4__/* .cmToFeet */ .br)(value), 2), dft = ref[0], dinches = ref[1];
                setFoot(dft);
                setInches(dinches);
                break;
            case "cm":
                setFoot(value);
                break;
            case "m":
                setFoot(value / 100);
                break;
            default:
                break;
        }
    }, [
        heightMetric
    ]);
    var weightHandler = function(e) {
        setWeight(e.target.value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "row ms-0 me-0 mt-3 bmi_calculator",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-xl-6 m-auto",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row m-0",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-8 col-md-8 m-auto p-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "fo-18 fw-600 txtco",
                                        children: "Weight"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-3 col-sm-2 col-md-2 m-auto p-1",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        value: weight,
                                        className: "w-100 calculatorInput",
                                        onChange: weightHandler,
                                        max: weightMetric === "kg" ? 150 : 300
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-3 col-sm-2 col-md-2 m-auto p-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "buttonGroups",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                            className: "calculatorInput2 txtco fw-700",
                                            value: weightMetric,
                                            onChange: function(e) {
                                                return setWeightMetric(e.target.value);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                    value: "kg",
                                                    children: "Kg"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                    value: "lbs",
                                                    children: "Lbs"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_calculator_Slider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            name: "weight",
                            value: weight,
                            onChange: function(value) {
                                return setWeight(value);
                            },
                            min: 0,
                            max: weightMetric === "kg" ? 150 : 300
                        }, "weight"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row m-0",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-8 col-md-8 m-auto p-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "fo-18 fw-600 txtco",
                                        children: "Height"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-3 col-sm-2 col-md-2 m-auto p-1",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        name: "heightFoot",
                                        className: "w-100 calculatorInput",
                                        value: foot,
                                        max: 7,
                                        min: 1,
                                        onChange: heightChangeHandler
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-3 col-sm-2 col-md-2 m-auto p-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                                        className: "calculatorInput2 txtco fw-700",
                                        onChange: function(e) {
                                            return setHeightMetric(e.target.value);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                value: "ft",
                                                children: "Ft"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                value: "cm",
                                                children: "cm"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                value: "m",
                                                children: "m"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        heightMetric === "ft" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row m-0",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-8 col-md-8 m-auto p-0"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-3 col-sm-2 col-md-2 m-auto p-1",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Input__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                        name: "heightInches",
                                        className: "w-100 calculatorInput",
                                        value: inches,
                                        max: 12,
                                        min: 0,
                                        onChange: heightChangeHandler
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-3 col-sm-2 col-md-2 m-auto p-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "buttonGroups",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "button2 fw-700 text-start",
                                            children: "In"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_calculator_Slider__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            name: "height",
                            value: height,
                            onChange: heightSliderChangeHandler,
                            min: 0,
                            max: 250
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row m-0 bmi_result",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-8 m-auto p-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "fo-18 fw-700 text-white mfo-13",
                                        children: [
                                            "Your BMI is",
                                            " ",
                                            calculateBMI(height, weight) > 0 ? calculateBMI(height, weight) : "0.0"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-6 col-sm-4 m-auto p-0 text-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "fo-18 fw-700 text-white mfo-13",
                                        children: renderText()
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-xl-6 mt-3 m-sm-auto ".concat((_Calculator_module_css__WEBPACK_IMPORTED_MODULE_6___default().meterContainer)),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/assets/bmi/background2.svg",
                            className: "".concat((_Calculator_module_css__WEBPACK_IMPORTED_MODULE_6___default().meterBackground)),
                            alt: "BMI Image"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/assets/bmi/needle.png",
                            className: "".concat((_Calculator_module_css__WEBPACK_IMPORTED_MODULE_6___default().meterNeedle)),
                            style: {
                                transform: "rotate(".concat(calculateDeg(), "deg)")
                            },
                            alt: "BMI Image"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Bmi);


/***/ }),

/***/ 1103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YB": function() { return /* binding */ poundToKg; },
/* harmony export */   "br": function() { return /* binding */ cmToFeet; },
/* harmony export */   "cc": function() { return /* binding */ calculateBmrAndTdee; },
/* harmony export */   "yE": function() { return /* binding */ feetToCM; }
/* harmony export */ });
/* unused harmony exports kgToPound, alanBaptistCalculator, harrisBenedictCalculator, miffinCalculator, katchMcardle */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9534);


var kgToPound = function(n) {
    return n * 2.205;
};
var poundToKg = function(n) {
    return n / 2.205;
};
var feetToCM = function(foot, inches) {
    return foot * 30.48 + inches * 2.54;
};
var cmToFeet = function(n) {
    var totalInches = n / 2.54;
    var feet = parseInt(totalInches / 12);
    var inches = totalInches - 12 * feet;
    return [
        parseInt(feet),
        inches.toFixed(2)
    ];
};
var normalizeMetrics = function(param) {
    var height = param.height, heightMetric = param.heightMetric, weight = param.weight, weightMetric = param.weightMetric;
    var h = heightMetric === "cm" ? height : feetToCM(height.foot, height.inches);
    var w = weightMetric === "kg" ? weight : poundToKg(weight);
    return {
        height: parseInt(h),
        weight: parseInt(w)
    };
};
var alanBaptistCalculator = function(param) {
    var gender = param.gender, weight = param.weight, activity = param.activity, _weightMetric = param.weightMetric, weightMetric = _weightMetric === void 0 ? "kg" : _weightMetric;
    var w = weightMetric === "kg" ? weight : poundToKg(weight);
    var bmr, tdee;
    if (gender === "Male") {
        bmr = 24 * w;
    } else {
        bmr = 22 * w;
    }
    tdee = bmr * activity;
    return {
        bmr: bmr.toFixed(2),
        tdee: tdee.toFixed(2)
    };
};
// For men: BMR = 66.5 + (13.75 * weight in kg) + (5.003 * height in cm) - (6.75 * age)
// For women: BMR = 655.1 + (9.563 * weight in kg) + (1.850 * height in cm) - (4.676 * age)
var harrisBenedictCalculator = function(param) {
    var gender = param.gender, weight = param.weight, height = param.height, activity = param.activity, age = param.age, _heightMetric = param.heightMetric, heightMetric = _heightMetric === void 0 ? "cm" : _heightMetric, _weightMetric = param.weightMetric, weightMetric = _weightMetric === void 0 ? "kg" : _weightMetric;
    var converted = normalizeMetrics({
        height: height,
        heightMetric: heightMetric,
        weight: weight,
        weightMetric: weightMetric
    });
    var bmr = 0;
    console.log(height, weight, heightMetric, weightMetric);
    if (gender === "Male") {
        bmr = 88.4 + 13.4 * converted.weight + 4.8 * converted.height - 5.68 * age;
    } else {
        bmr = 447.6 + 9.25 * converted.weight + 3.1 * converted.height - 4.33 * age;
    }
    return {
        bmr: bmr.toFixed(2),
        tdee: (bmr * activity).toFixed(2)
    };
};
// Formula
var miffinCalculator = function(param) {
    var gender = param.gender, weight = param.weight, activity = param.activity, height = param.height, age = param.age, heightMetric = param.heightMetric, weightMetric = param.weightMetric;
    var bmr = 0;
    var converted = normalizeMetrics({
        height: height,
        heightMetric: heightMetric,
        weight: weight,
        weightMetric: weightMetric
    });
    if (gender === "Male") {
        bmr = 9.99 * converted.weight + 6.25 * converted.height - 4.92 * age + 5;
    } else {
        bmr = 9.99 * converted.weight + 6.25 * converted.height - 4.92 * age - 161;
    }
    return {
        bmr: bmr.toFixed(2),
        tdee: (bmr * activity).toFixed(2)
    };
};
var katchMcardle = function(param) {
    var weight = param.weight, bodyFat = param.bodyFat, activity = param.activity, weightMetric = param.weightMetric, height = param.height, heightMetric = param.heightMetric;
    var converted = normalizeMetrics({
        height: height,
        heightMetric: heightMetric,
        weight: weight,
        weightMetric: weightMetric
    });
    var bmr = 370 + 21.6 * (1 - bodyFat / 10000) * converted.weight;
    return {
        bmr: bmr.toFixed(2),
        tdee: (bmr * activity).toFixed(2)
    };
};
var calculateBmrAndTdee = function(_param) {
    var formula = _param.formula, values = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "formula"
    ]);
    switch(formula){
        case "harris-benedict":
            return harrisBenedictCalculator((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, values));
        case "mifflin":
            return miffinCalculator((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, values));
        case "alan-baptist":
            return alanBaptistCalculator((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, values));
        case "katch-mcardle":
            return katchMcardle((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, values));
        default:
            return alanBaptistCalculator((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, values));
    }
};


/***/ }),

/***/ 4576:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"meterContainer":"Calculator_meterContainer__ZpT_4","meterBackground":"Calculator_meterBackground__No5wv","meterNeedle":"Calculator_meterNeedle__3SWWC"};

/***/ }),

/***/ 7122:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"calcSlider":"Slider_calcSlider__Nax0I","calcSliderBlue":"Slider_calcSliderBlue__Ee9VJ","calcSliderYellow":"Slider_calcSliderYellow__luQly","calcSliderGreen":"Slider_calcSliderGreen__odMb1","sliderValue":"Slider_sliderValue__4HAY7","sliderSubcontainer":"Slider_sliderSubcontainer__laKx7","inactive":"Slider_inactive___rAco"};

/***/ }),

/***/ 943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 3375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 9534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 828:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(3375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(1566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 1566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

}]);